import React from 'react'
import { ComponentData } from '../data/ComponentContext'
import { Row } from 'react-bootstrap'
import Col from 'react-bootstrap/Col';

function MotivationSlider({ motivation }) {

  const { SliderTexts, updatePoints, sliderPoints } = ComponentData()

  const trackSections = []
  for (let index = 0; index < 13; index++) {
    trackSections.push(
      <div className={sliderPoints[motivation] > index ? 'track-section selected' : 'track-section'} key={'track-section-' + index} />
    )
  }

  return (

    <Col md={6}>
      <div className='content-box'>
        <Row className="headline_texts">
          <Col md={11}>
            <div className="configuration-text">
              <p>{SliderTexts[motivation].text}</p>
              <h3>{SliderTexts[motivation].heading}</h3>
            </div>
          </Col>
          <Col md={1}>
            <div className="points"><p>{sliderPoints[motivation]}</p></div>
          </Col>
        </Row>
        <div className="slider-area">
          <input className="slider" type="range" min="0" max="13" value={sliderPoints[motivation]} onChange={
            (e) => {
              updatePoints(motivation, e.target.valueAsNumber)
            }} />
          <div className="track-background"></div>
          <div className="track">
            {trackSections}
          </div>
        </div>
      </div>
    </Col>

  )
}

export default MotivationSlider